import React from 'react';
import ImageElement from './utils/question/imageElement';
import Video from './utils/question/video';
import { connect } from 'react-redux';
import Zoom from '../utils/animations/zoom';
const mapStateToProps = (state) => {
	const {
		element_name,
		elementId,
		isFeedback,
		elementType,
		leftSectionProps,
	} = state.rootReducer.testPageDetails;

	const unitName = state.rootReducer.myCourse?.unitName;
	const isRetail = state.rootReducer.loginDetails?.isRetail;
	return {
		unitName,
		isRetail,
		element_name,
		elementId,
		isFeedback,
		elementType,
		leftSectionProps,
	};
};

const InsQuestion = ({
	leftSectionProps: { videoId, imagesrc, queDesc, liveClassURL, question, questionId },
}) => {
	return (
		<section className="quiz-area-question">
			<Zoom
				className="btn btn-icon pull-right pad-no mar-no help-popup-link"
				data-toggle="tooltip"
				data-placement="top"
				title="Help"
			>
				<i
					className="fa fa-question-circle fa-2x"
					data-toggle="modal"
					data-target="#help-popup"
					aria-hidden="true"
				></i>
			</Zoom>

			<h4>{question} </h4>
			<br />
			{(!!queDesc || !!imagesrc || !!videoId) && (
				<div className="paratext">
					{(!!videoId && <Video key={questionId} videoId={videoId} queDesc={queDesc} />) ||
						((!!queDesc || !!imagesrc) && (
							<ImageElement
								imagesrc={imagesrc}
								liveClassURL={liveClassURL}
								queDesc={queDesc}
							/>
						))}
				</div>
			)}
		</section>
	);
};

export default connect(mapStateToProps)(InsQuestion);
